import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import _ from 'lodash';

interface uiState {
	page: string;
	history: string[];
	to?: string;
	checkBeforeNavigate: boolean;
	isMobile: boolean;
}

const initialState: uiState = {
	page: '/dashboard',
	history: [''],
	checkBeforeNavigate: false,
	isMobile: window.innerWidth < 600,
};

export const uiSlice = createSlice({
	name: 'ui',
	initialState,
	reducers: {
		togglePage: (state, action: PayloadAction<string | undefined>) => {
			state.to = action.payload;
		},
		setPage: (state, action: PayloadAction<string>) => {
			state.to = undefined;
			state.checkBeforeNavigate = false;
			state.history.push(state.page);
			state.page = action.payload;
		},
		setCheckBeforeNavigate: (state, action: PayloadAction<boolean>) => {
			state.checkBeforeNavigate = action.payload;
		},
		setMobile: (state, action: PayloadAction<boolean>) => {
			state.isMobile = action.payload;
		},
	},
});

export const { togglePage, setPage, setCheckBeforeNavigate, setMobile } = uiSlice.actions;

export const ifPageChange = (state: any) => {
	return state.ui?.to && !_.isEqual(state.ui.to, state.ui.page) ? true : false;
};
const uiSelector = (state) => state.ui;
export const cancelDialogProps = createSelector([uiSelector], (state: any) => {
	const popupType = ifPageChange(state) ? 'leave' : 'cancel';
	const page = state.page.split('/')[1];

	return {
		title: `page.${page}.popup.${popupType}.title`,
		subTitle: `page.${page}.popup.${popupType}.text`,
		cancelLabel: `page.${page}.popup.${popupType}.approve_button.text`,
		continueLabel: `page.${page}.popup.${popupType}.cancel_button.text`,
	};
});

export const getToNavigation = (state: any) => {
	return state.ui.to;
};

export const getUi = (state: any) => {
	return state.ui;
};

export const getHistory = (state: any) => {
	return state.ui.history;
};

export const getMobile = (state: any) => {
	return state.ui.isMobile;
};
export const getPage = (state: any) => {
	return state.ui.page;
};

export default uiSlice.reducer;
